module.exports = __webpack_public_path__ + "img/logo_navbar.303b9297.png";